// extracted by mini-css-extract-plugin
module.exports = {"ScreenDivisionTop":"CardListScreen_ScreenDivisionTop__3T4H-","ScreenDivisionBottom":"CardListScreen_ScreenDivisionBottom__2VUFz"};